<template>
    <div class="col-12 col-md-12 mt-5">
        <div v-if="objectIsNotEmpty(validation_errors)" id="error-list">
            <np-notice v-for="(error, index) in validation_errors" :key="index" :notice-class="'alert-danger'"
                       :notice="getValidationMessage(error)">
            </np-notice>
        </div>
        <div class="" v-else>
            <np-skeleton type="panel_only">

            </np-skeleton>
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
            <div class="col-12">
                <div class="my-3">
                    <button class="btn btn-danger" @click="backPage"> {{lang('go_back')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {NPNotice, NPSkeleton} from 'netpify/components';
    import {
        mapState
    } from 'pinia';
    import * as types from '../../../stores/constants'
import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "ValidationError",
        components: {
            'np-notice': NPNotice,
            'np-skeleton': NPSkeleton,
        },
        data: function () {
            return {
                can_view: false,
                openStatusId: '',
                page_label: 'tab_review',
            }
        },
        metaInfo () {
            return {
                title: this.lang('errors')
            }
        },
        created: function () {
           // this.redirect_to_error_tab = false;
        },
        mounted: function () {
            objCommon.radios_as_selects();
        },
        methods: {
            getValidationMessage: function (error) {
                let message = '';
                if (this.objectIsNotEmpty(error)) {
                  if (error.message.includes('com.elavon')){ //break up the elavon message in mobile view
                    message = '<span style="word-break: break-all"><b>' + this.lang('error') + ' ' + error.error_code + '</b>: ' + error.message +'</span>';
                  }else{
                    message = '<b>' + this.lang('error') + ' ' + error.error_code + '</b>: ' + error.message;

                  }
                }
                return message;
            },
            isOpenApplication: function()  {
                if (this.applicationStatusKey === '-'){
                    return true;
                }
                return  this.applicationStatusKey === types.APP_STATUS_OPEN;
            },
            backPage: function () {
                if(this.isOpenApplication) {
                    this.$router.push({path: `/application/edit/${this.$route.params.application_reference}/review/`})
                } else {
                    this.$router.push({path: `/application/view/${this.$route.params.application_reference}/review/`})
                }
            },
        },
        watch: {},
        computed: {
            ...mapState(useApplicationStore,{
                parameters: 'parameters',
                validation_errors: 'validation_errors',
                redirect_to_error_tab: 'redirect_to_error_tab'
            }),
            url: function () {
                return window.location.href;
            },
        }
    }
</script>

<style scoped>

</style>
